export const pascalToSnakeCase = (str) => {
  if (!str) return '';

  return str.toString().split(/(?=[A-Z])/).join('_').toLowerCase();
};
